class ProductCollectionSidebar extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.product-collection-sidebar__viewport');
    this.list = this.querySelector('.product-collection-sidebar__list');
    this.prevButton = this.querySelector('.product-collection-sidebar__button--prev');
    this.nextButton = this.querySelector('.product-collection-sidebar__button--next');

    if (!this.viewport || !this.list) return;

    this.handlePrev = () => this.scrollByCard(-1);
    this.handleNext = () => this.scrollByCard(1);
    this.handleScroll = () => this.updateButtons();
    this.handleResize = () => this.setViewportHeight();

    this.prevButton?.addEventListener('click', this.handlePrev);
    this.nextButton?.addEventListener('click', this.handleNext);
    this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize);

    requestAnimationFrame(() => {
      this.setViewportHeight();
      this.updateButtons();
    });
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.handlePrev);
    this.nextButton?.removeEventListener('click', this.handleNext);
    this.viewport?.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  scrollByCard(direction) {
    const firstItem = this.list.querySelector('.product-collection-sidebar__item');
    if (!firstItem) return;

    const styles = window.getComputedStyle(this.list);
    const gap = parseFloat(styles.rowGap || styles.gap || 0);
    const step = firstItem.getBoundingClientRect().height + gap;

    this.viewport.scrollBy({
      top: step * direction,
      behavior: 'smooth',
    });
  }

  setViewportHeight() {
    const items = this.list.querySelectorAll('.product-collection-sidebar__item');
    if (!items.length) return;

    const productRoot = this.closest('.product');
    const mediaWrapper = productRoot?.querySelector('.product__media-wrapper');
    const sidebarStyles = window.getComputedStyle(this);
    const sidebarGap = parseFloat(sidebarStyles.rowGap || sidebarStyles.gap || 0);
    const children = Array.from(this.children);
    const nonViewportHeight = children
      .filter((child) => child !== this.viewport)
      .reduce((total, child) => total + child.getBoundingClientRect().height, 0);
    const totalGapHeight = sidebarGap * Math.max(children.length - 1, 0);
    const targetHeight = mediaWrapper?.getBoundingClientRect().height || 0;

    if (targetHeight > 0) {
      const availableViewportHeight = targetHeight - nonViewportHeight - totalGapHeight;

      if (availableViewportHeight > 0) {
        this.viewport.style.maxHeight = `${Math.min(availableViewportHeight, this.viewport.scrollHeight)}px`;
        return;
      }
    }

    if (items.length <= 3) {
      this.viewport.style.maxHeight = 'none';
      return;
    }

    const listStyles = window.getComputedStyle(this.list);
    const listGap = parseFloat(listStyles.rowGap || listStyles.gap || 0);
    const itemHeight = items[0].getBoundingClientRect().height;
    const fallbackHeight = itemHeight * 3 + listGap * 2;

    this.viewport.style.maxHeight = `${fallbackHeight}px`;
  }

  updateButtons() {
    if (!this.prevButton || !this.nextButton) return;

    const maxScroll = this.viewport.scrollHeight - this.viewport.clientHeight;
    const currentScroll = this.viewport.scrollTop;

    this.prevButton.disabled = currentScroll <= 4;
    this.nextButton.disabled = currentScroll >= maxScroll - 4;
  }
}

if (!customElements.get('product-collection-sidebar')) {
  customElements.define('product-collection-sidebar', ProductCollectionSidebar);
}